function NotFound() {
    return <h1 style={{ textAlign: "center", marginTop: "100px" }}>
      404 - Page Not Found
    </h1>;
  }
  export default NotFound;